export default "__VITE_ASSET__CWVFCC_u__"